import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';
import './PublicHeader.css';

function PublicHeader() {
  const location = useLocation();

  return (
    <header className="public-header">
      <div className="public-header-container">
        <div className="logo-container">
          <Link to="/" className="logo">DEUS</Link>
          <div className="tagline">GOD IN YOVR MACHINE</div>
        </div>
        
        <nav className="nav-links">
          <Link to="/" className={location.pathname === "/" ? "active" : ""}>
            Home
          </Link>
          <Link to="/pricing" className={location.pathname === "/pricing" ? "active" : ""}>
            Pricing
          </Link>
          {/* Add additional navigation links as needed */}
        </nav>
        
        <div className="header-actions">
          <ThemeToggle />
          <Link to="/auth" className="app-button">
            App
          </Link>
        </div>
      </div>
    </header>
  );
}

export default PublicHeader; 